import React from "react";
import { AlertTriangle, Megaphone } from "lucide-react";
import { isUnverified } from "../lib/media";

// Standard campaign framing: Paws on Record is calling for help, not rescuing.
export default function CampaignNotice({ rescue }) {
  return (
    <div className="space-y-2" data-testid="campaign-notice">
      {isUnverified(rescue) && (
        <div className="border-l-4 border-amber-600 bg-amber-50 text-amber-900 px-4 py-3 text-sm flex gap-2" data-testid="campaign-unconfirmed">
          <AlertTriangle size={16} className="shrink-0 mt-0.5" />
          <span>
            <b>Reported incident.</b> The animals were reportedly abandoned in {rescue.city}, {rescue.state}. Their current location and rescue
            status are <b>unconfirmed</b>.
          </span>
        </div>
      )}
      <div className="border-l-4 border-zinc-900 bg-zinc-50 px-4 py-3 text-sm flex gap-2" data-testid="campaign-calling-for-help">
        <Megaphone size={16} className="shrink-0 mt-0.5" />
        <span><b>Paws on Record is calling for help.</b> We are not the rescue organization — we are connecting these animals with rescues and people willing to help.</span>
      </div>
    </div>
  );
}
